module.exports = __webpack_public_path__ + "img/qrcode_loading.c222377c.gif";